import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./StudentIdCard5.css";

// "1998-08-20" -> "20-08-1998"
const formatDob = (dob) => {
  if (!dob) return "";
  const [y, m, d] = String(dob).slice(0, 10).split("-");
  return y && m && d ? `${d}-${m}-${y}` : dob;
};

export default function StudentIdCard5({ data, batch }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    try {
      setSetting(JSON.parse(localStorage.getItem("setting") || "{}"));
    } catch {
      setSetting({});
    }
  }, []);

  const student = data?.student_info;
  const logo = setting?.logo_img ? imgBaseUrl + setting.logo_img : null;

  const address = [student?.village, student?.district, student?.state]
    .filter(Boolean)
    .join(", ");

  const phones = [setting?.mobile, setting?.secondary_mobile]
    .filter(Boolean)
    .join(", ");

  const rows = [
    ["Reg. No.", student?.registration_no],
    ["Name", student?.name],
    ["Father’s Name", student?.father_name],
    ["DOB", formatDob(student?.dob)],
    ["Mobile No.", student?.phone],
    ["Address", `${address}${student?.zipcode ? " " + student.zipcode : ""}`],
    ["Course", batch?.course?.title],
    ["Hostel", student?.hostel_status],
  ];

  return (
    <div
      className="id5-card"
      style={{ "--id5-watermark": logo ? `url(${logo})` : "none" }}
    >
      {/* background shapes: peach block + maroon header with curved notch */}
      <svg
        className="id5-bg"
        viewBox="0 0 540 500"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M260 200 L540 190 L540 400 L430 300 Z" fill="#fde6d0" />
        <path
          d="M0 0 H540 V240 L450 200 Q430 194 410 194 H190 Q165 194 150 212 L135 228 Q122 245 100 245 H0 Z"
          fill="#5b0a2e"
        />
        <rect x="205" y="192" width="90" height="8" fill="#470822" />
      </svg>

      <div className="id5-logo-wrap">
        {logo ? (
          <img src={logo} alt="" className="id5-logo" />
        ) : (
          <div className="id5-inst-name">{setting?.name}</div>
        )}
      </div>

      {setting?.tag_line && (
        <div className="id5-tagline">{setting.tag_line}</div>
      )}

      <img
        className="id5-photo"
        src={
          student?.profile_picture
            ? imgBaseUrl + student.profile_picture
            : "/files/user.png"
        }
        alt=""
      />

      <div className="id5-adm">
        Admission Date : {formatToDate(student?.admission_date)}
      </div>

      <div className="id5-details">
        {rows.map(([label, value]) => (
          <div className="id5-row" key={label}>
            <div>{label}</div>
            <div className="id5-colon">:</div>
            <div className="id5-value">{value}</div>
          </div>
        ))}
      </div>

      {setting?.signature && (
        <div className="id5-sign">
          <img src={imgBaseUrl + setting.signature} alt="" />
          <span>Auth. Signature</span>
        </div>
      )}

      <div className="id5-footer">{phones && `M. ${phones}`}</div>
    </div>
  );
}
